const API_TYPE = {
  QN_APP:  'QN.app',
  QN_GATEWAY: 'QN.gateway',
  QN_JDY: 'QN.jdy',
  TOP: 'QN.top',
  AJAX: 'ajax',
};

export default API_TYPE;



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-api-type.js